import './style.scss';

const COOKIE_NAME = 'cpd_unlocked';

function getCookie(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? match[2] : null;
}

function setCookie(name, value, days) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${value}; expires=${expires}; path=/`;
}

export function sign_to_watch_block() {
  const blocks = document.querySelectorAll('.sign_to_watch_block');
  if (blocks.length === 0) return;

  const isUnlocked = () => getCookie(COOKIE_NAME) === '1';

  blocks.forEach(block => {
    if (isUnlocked()) {
      block.classList.add('signed-up');
    }

    // Listen for HubSpot form submission on this block
    window.addEventListener('message', (e) => {
      if (
        e.data &&
        e.data.type === 'hsFormCallback' &&
        e.data.eventName === 'onFormSubmitted'
      ) {
        setCookie(COOKIE_NAME, '1', 365);
        block.classList.add('signed-up');
      }
    });
  });
}
